import SettingsStore from "./SettingsStore";
import UserStore from "./UserStore";
import { IAppStore } from "./Interfaces";
import { addMessage, callMessages } from "../helpers/flashMessage";
import ee from "../services/EventEmitter";
import { UNAUTHORIZED_ACTION } from "../constants/events";
import { LOGIN_PATH } from "../constants/auth";
import CountriesStore from "./CountriesStore";

export default class AppStore implements IAppStore {
  userStore: UserStore;

  settingsStore: SettingsStore;

  countryStore: CountriesStore;

  constructor() {
    this.userStore = new UserStore();
    this.settingsStore = new SettingsStore();
    this.countryStore = new CountriesStore();

    ee.once(UNAUTHORIZED_ACTION, (item) => {
      addMessage(item as string, "error");
      window.location.href = LOGIN_PATH;
    });

    callMessages();
  }
}
